import { render, staticRenderFns } from "./Abandon.vue?vue&type=template&id=2cfa2ff8&scoped=true&"
import script from "./Abandon.vue?vue&type=script&lang=js&"
export * from "./Abandon.vue?vue&type=script&lang=js&"
import style0 from "./Abandon.vue?vue&type=style&index=0&id=2cfa2ff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa2ff8",
  null
  
)

export default component.exports